import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { mapHttpError } from './app-error-catalog';
import { isAppError } from './app-error.model';

export const appErrorInterceptor: HttpInterceptorFn = (request, next) => {
  return next(request).pipe(
    catchError((error: unknown) => {
      if (isAppError(error)) {
        return throwError(() => error);
      }

      if (error instanceof HttpErrorResponse) {
        return throwError(() => mapHttpError(error));
      }

      return throwError(() => error);
    })
  );
};